import AppBar from '@mui/material/AppBar';
import { ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';
import clsx from 'clsx';

function FooterLayout1(props) {
  const footerTheme = useSelector(selectFooterTheme);

  const socialMediasUrls = [
    {
      id: 1,
      url: `https://www.instagram.com/uzinfocom_official/?hl=en`,
      imgUrl: `assets/icons/social-medias/instagram.svg`,
      extraClass: '',
    },
    {
      id: 2,
      url: `https://www.facebook.com/uzinfocom.uz/`,
      imgUrl: `assets/icons/social-medias/facebook.svg`,
      extraClass: '',
    },
    {
      id: 3,
      url: `https://uz.linkedin.com/company/uzinfocom`,
      imgUrl: `assets/icons/social-medias/linkedin.svg`,
      extraClass: '',
    },
    {
      id: 4,
      url: `https://t.me/s/uzinfocomofficial`,
      imgUrl: `assets/icons/social-medias/telegram.svg`,
      extraClass: '',
    },
    {
      id: 5,
      url: 'https://www.youtube.com/results?search_query=uzinfocom',
      imgUrl: `assets/icons/social-medias/youtube2.png`,
      extraClass: 'p-2',
    },
  ];

  return (
    <ThemeProvider theme={footerTheme}>
      <AppBar
        id="fuse-footer"
        className={clsx('relative z-20 shadow-md dark:bg-dark', props.className)}
        color="default"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? footerTheme.palette.background.paper
              : footerTheme.palette.background.default,
        }}
      >
        <Toolbar className="min-h-32 px-8 sm:px-12 py-0 flex items-center overflow-x-auto shadow-2">
          <div className="dark:text-white">&copy; UZINFOCOM</div>
          {process.env.REACT_APP_COMPANY_NAME === 'Uzinfocom' && (
            <ul className="flex items-center gap-10 ml-10">
              {socialMediasUrls.map((social) => {
                return (
                  <li key={social.id}>
                    <a
                      href={social.url}
                      className={`w-24 h-24 block bg-white dark:bg-dark ${social.extraClass}`}
                    >
                      <img className="w-full h-full" src={social.imgUrl} />
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default memo(FooterLayout1);
